import Default from './Default/Default'

export const Layout = { Default }
